import React, { FC, useCallback, useMemo, useState } from 'react';
import DataTable from 'src/components/DataTable';
import {
  getCertificatesFiles,
  getCoursesId,
  getCoursesStatisticsById,
  getCoursesStatisticsByIdExcel,
  getWebinarId,
} from 'src/api';
import { Link, useParams } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import columns from './columns';
import className from './../../StatisticsManagementPage.module.scss';
import { Button } from '@material-ui/core';
import { downloadFileUtil } from '../../../../User/CertificatesPage';
import { getFileNameFromContentDisposition } from '../../../../../utils/helpers/download';
import download from 'downloadjs';
import { PaginationQueryParams } from '../../../../../api/types';

type Props = unknown;

const CourseStatisticsDetailPage: FC<Props> = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { coursesId } = useParams();
  const [course, setCourse] = useState();

  const { t } = useTranslation();

  useMemo(async () => {
    try {
      const { data } = await getCoursesId({ urlParams: { coursesId } });
      setCourse(data);
    } catch {
      enqueueSnackbar(t('ERRORS.SOMETHING_WENT_WRONG'), { variant: 'error' });
    }
  }, [coursesId]);

  const fetchRows = async params => {
    const data = await getCoursesStatisticsById({
      queryParams: params.queryParams,
      urlParams: { coursesId },
    });
    return data;
  };

  const downloadExcel = async (event: React.MouseEvent) => {
    event.stopPropagation();

    getCoursesStatisticsByIdExcel({
      urlParams: { coursesId },
    }).then(response => {
      const {
        data,
        headers: { filename, 'content-disposition': contentDisposition },
      } = response;

      const nameFromDisposition = getFileNameFromContentDisposition(contentDisposition);
      const name = nameFromDisposition;

      download(data, name);
    });
  };

  return (
    <>
      <Container disableGutters maxWidth="lg">
        <div className={className.navigationActions}>
          <Link
            className={`${className.action} ${className.link}`}
            to={{ pathname: `/statistics` }}
          >
            <Button variant="contained" size="large" color="default">
              {t('COMMON.BACK')}
            </Button>
          </Link>
          <Button
            className={className.actionRight}
            onClick={downloadExcel}
            variant="contained"
            size="large"
            color="primary"
          >
            {t('COMMON.EXPORT_TO_EXCEL')}
          </Button>
        </div>
        <Typography className={className.tableHeader} variant="h6" id="tableTitle">
          {course?.name}
        </Typography>
        <DataTable getRowsApi={fetchRows} columns={columns} />
      </Container>
    </>
  );
};

export default CourseStatisticsDetailPage;
